<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Nama Lengkap <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="nama" rules="required">
            <b-form-input
              id="name"
              v-model="berkas.name"
              :state="errors.length > 0 ? false : null"
              placeholder="Nama Lengkap"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Nama Ijazah <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="nama" rules="required">
            <b-form-input
              id="nama_ijazah"
              v-model="berkas.nama_ijazah"
              :state="errors.length > 0 ? false : null"
              placeholder="Nama Ijazah"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for="">NPM <span style="color: red; font-size: 16px">*</span></label>
          <validation-provider #default="{ errors }" name="npm" rules="required">
            <b-form-input
              id="npm"
              v-model="berkas.npm"
              :state="errors.length > 0 ? false : null"
              placeholder="NPM"
              :maxlength="10"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Angkatan <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="angkatan" rules="required">
            <b-form-input
              id="angkatan"
              v-model="berkas.angkatan"
              :state="errors.length > 0 ? false : null"
              placeholder="2023"
              type="number"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Tempat Lahir <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="tempat_lahir" rules="required">
            <b-form-input
              id="tempat_lahir"
              v-model="berkas.tempat_lahir"
              :state="errors.length > 0 ? false : null"
              placeholder="Tempat Lahir"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Tanggal Lahir <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider
            #default="{ errors }"
            name="tanggal_lahir"
            rules="required"
          >
            <flat-pickr
              v-model="berkas.tanggal_lahir"
              class="form-control invoice-edit-input"
              :config="flatpickrConfig"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Alamat Mahasiswa <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="alamat" rules="required">
            <b-form-textarea
              :state="errors.length > 0 ? false : null"
              id="alamat"
              v-model="berkas.alamat"
              placeholder="alamat..."
              rows="3"
              :disabled="true"
            ></b-form-textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Alamat Orang Tua <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="alamat" rules="required">
            <b-form-textarea
              :state="errors.length > 0 ? false : null"
              id="alamat"
              v-model="berkas.alamat_orang_tua"
              placeholder="alamat..."
              rows="3"
              :disabled="true"
            ></b-form-textarea>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Pekerjaan Orang Tua <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider
            #default="{ errors }"
            name="pekerjaan_orang_tua"
            rules="required"
          >
            <b-form-input
              id="pekerjaan_orang_tua"
              v-model="berkas.pekerjaan_orang_tua"
              :state="errors.length > 0 ? false : null"
              placeholder="Pekerjaan Orang Tua"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Jabatan Orang Tua <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider
            #default="{ errors }"
            name="jabatan_orang_tua"
            rules="required"
          >
            <b-form-input
              id="jabatan_orang_tua"
              v-model="berkas.jabatan_orang_tua"
              :state="errors.length > 0 ? false : null"
              placeholder="Jabatan Orang Tua"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Nomor Telp <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="nomor_telp">
            <b-form-input
              id="nomor_telp"
              v-model="berkas.nomor_telp"
              :state="errors.length > 0 ? false : null"
              placeholder="Nomor Telpon Rumah"
              type="number"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Nomor HP <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="nomor_hp" rules="required">
            <b-form-input
              id="nomor_hp"
              v-model="berkas.nomor_hp"
              :state="errors.length > 0 ? false : null"
              placeholder="Nomor HP"
              type="number"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Alamat Email UI <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="email" rules="required|email">
            <b-form-input
              id="email"
              v-model="berkas.email_ui"
              type="email"
              :state="errors.length > 0 ? false : null"
              placeholder="john.doe@email.com"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Alamat Email Selain UI
            <span style="color: red; font-size: 16px">*</span></label
          >
          <validation-provider #default="{ errors }" name="email" rules="required|email">
            <b-form-input
              id="email"
              v-model="berkas.email_selain_ui"
              type="email"
              :state="errors.length > 0 ? false : null"
              placeholder="john.doe@email.com"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="berkas.jenjang_id != null">
      <b-col md="6">
        <b-form-group>
          <label for="">Judul <span style="color: red; font-size: 16px">*</span></label>
          <validation-provider #default="{ errors }" name="judul" rules="required">
            <b-form-textarea
              id="judul"
              v-model="berkas.judul"
              :state="errors.length > 0 ? false : null"
              placeholder="Judul"
              rows="5"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for=""
            >Penelitian Payung <span style="color: blue">(Opsional)</span></label
          >
          <validation-provider #default="{ errors }" name="penelitian_payung">
            <b-form-input
              id="penelitian_payung"
              v-model="berkas.penelitian_payung"
              :state="errors.length > 0 ? false : null"
              placeholder="Penilitian Payung"
              :disabled="true"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="berkas.jenjang_id != null">
      <b-row>
        <b-col md="12">
          <div
            class="d-flex justify-content-end"
            style="margin-bottom: 20px; margin-top: 20px"
          >
            <b-spinner
              style="margin-right: 10px; margin-top: 5px"
              :variant="'dark'"
              v-if="showSpinner == 1"
            ></b-spinner>
            <b-button
              v-if="berkas.jenjang_id == '9221e9f05c40488a60128e9ced01aa1a'"
              @click="tambahWaktuUjian()"
              variant="outline-primary"
              style="margin-right: 10px"
              ><feather-icon icon="PlusIcon" /> Tambah Waktu Ujian
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row v-for="item in berkas.waktu_ujian" :key="item.id" class="mb-2">
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Awal Bimbingan Skripsi
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="awal_bimbingan"
              rules="required"
            >
              <flat-pickr
                v-model="berkas.awal_bimbingan"
                class="form-control invoice-edit-input"
                :config="flatpickrConfig"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Akhir Bimbingan Skripsi
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="akhir_bimbingan"
              rules="required"
            >
              <flat-pickr
                v-model="berkas.akhir_bimbingan"
                class="form-control invoice-edit-input"
                :config="flatpickrConfig"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Usulan Tanggal Ujian
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="tanggal_sidang"
              rules="required"
            >
              <flat-pickr
                v-model="item.tanggal_ujian"
                class="form-control invoice-edit-input"
                :config="ConfigTanggalUjian"
                :key="counter"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group>
            <label for=""
              >Usulan Waktu Ujian
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="waktu_ujian"
              rules="required"
            >
              <v-select
                id="waktu_ujian_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.waktu.options"
                v-model="item.waktu_ujian_id"
                placeholder="Pilih Waktu"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="berkas.jenjang_id != null">
        <b-col md="12">
          <div class="d-flex justify-content-end" style="margin-top: 20px">
            <b-spinner
              style="margin-right: 10px; margin-top: 5px"
              :variant="'dark'"
              v-if="showSpinnerPembimbing == 1"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="berkas.jenjang_id != null"
        v-for="(item, index) in berkas.dosen_pembimbing"
        :key="item.id"
        style="margin-bottom: 20px"
      >
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Dosen Pembimbing {{ (index += 1) }}
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Dosen Pembimbing"
              rules="required"
            >
              <v-select
                id="dosen_pembimbing"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.dosen.options"
                v-model="item.dosen_pembimbing_id"
                placeholder="Pilih Dosen Pembimbing"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group>
            <label for=""
              >Alamat Email Pembimbing {{ index }}
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="email"
              rules="required|email"
            >
              <b-form-input
                id="email"
                v-model="item.email"
                type="email"
                :state="errors.length > 0 ? false : null"
                placeholder="john.doe@email.com"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="$can('set-pembimbing-utama', 'pengajuan-sidang')">
          <b-form-group>
            <label for=""
              >Pembimbing Utama ?<span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Pembimbing Utama"
              rules="required"
            >
              <v-select
                id="dosen_pembimbing"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="dosenUtamaOption.options"
                v-model="item.pembimbing_utama"
                placeholder="Pilih"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="berkas.jenjang_id != null">
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Dosen Pembimbing Akademik <span style="color: red">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Dosen Pembimbing Akademik"
              rules="required"
            >
              <v-select
                id="dosen_pembimbing"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.dosen.options"
                v-model="berkas.dosen_pembimbing_akademik_id"
                placeholder="Pilih Dosen Pembimbing Akademik"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="berkas.jenjang_id != null">
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Dosen Pembimbing Skripsi 2
              <span style="color: blue">(Opsional)</span></label
            >
            <validation-provider #default="{ errors }" name="Dosen Pembimbing Magang">
              <v-select
                id="dosen_pembimbing"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.dosen.options"
                v-model="berkas.dosen_pembimbing_magang_id"
                placeholder="Pilih Dosen Pembimbing Magang"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="berkas.jenjang_id != null">
        <b-col md="12">
          <div class="d-flex justify-content-end" style="margin-top: 20px">
            <b-spinner
              style="margin-right: 10px; margin-top: 5px"
              :variant="'dark'"
              v-if="showSpinnerPenguji == 1"
            ></b-spinner>
            <b-button
              v-if="berkas.jenjang_id == '9221e9f05c40488a60128e9ced01aa1a'"
              @click="tambahPenguji()"
              variant="outline-primary"
              style="margin-right: 10px"
              ><feather-icon icon="PlusIcon" /> Tambah Penguji
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row
        class="mt-3"
        v-if="berkas.jenjang_id != null"
        v-for="(item, index) in berkas.dosen_penguji"
        :key="item.id"
        style="margin-bottom: 20px"
      >
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Dosen Penguji {{ (index += 1) }}
              <span style="color: red; font-size: 16px">{{
                index === 1 ? "*" : ""
              }}</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Dosen Penguji"
              :rules="index == 1 ? 'required' : ''"
            >
              <v-select
                id="dosen_penguji_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.dosen.options"
                v-model="item.dosen_penguji_id"
                placeholder="Pilih Dosen Penguji"
                :disabled="berkas.role == 'mahasiswa' || berkas.role == 'pembimbing'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for=""
              >Apakah Penguji {{ index }} sudah setuju untuk menguji skripsi Anda?
              <span style="color: red; font-size: 16px">{{
                index === 1 ? "*" : ""
              }}</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Dosen Pembimbing"
              :rules="index == 1 ? 'required' : ''"
            >
              <v-select
                id="dosen_pembimbing"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="masterData.jawaban.options"
                v-model="item.jawaban_persetujuan_id"
                placeholder="Pilih Jawaban"
                :disabled="berkas.role == 'mahasiswa' || berkas.role == 'pembimbing'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="$can('set-penguji-utama', 'pengajuan-sidang')">
          <b-form-group>
            <label for=""
              >Penguji Utama ?<span style="color: red; font-size: 16px">{{
                index === 1 ? "*" : ""
              }}</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="Dosen Penguji"
              :rules="index == 1 ? 'required' : ''"
            >
              <v-select
                id="dosen_penguji"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(val) => val.value"
                :options="dosenUtamaOption.options"
                v-model="item.penguji_utama"
                placeholder="Pilih"
                :disabled="berkas.role == 'mahasiswa' || berkas.role == 'pembimbing'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="berkas.jenjang_id == 'd7502c8f68d11921bdf217e8fd173a69'">
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Semester yang dijalani saat ini
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="semester_saat_ini"
              rules="required"
            >
              <b-form-input
                id="semester_saat_ini"
                v-model="berkas.semester_saat_ini"
                :state="errors.length > 0 ? false : null"
                placeholder="Semester yang dijalani saat ini"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Lama Bimbingan Skripsi (Dalam Bulan)
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="lama_bimbingan"
              rules="required"
            >
              <b-form-input
                id="lama_bimbingan"
                v-model="berkas.lama_bimbingan"
                :state="errors.length > 0 ? false : null"
                placeholder="Dalam Bulan"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Jumlah SKS diperoleh (Acuan SIAK NG)
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="jumlah_sks_diperoleh"
              rules="required"
            >
              <b-form-input
                id="jumlah_sks_diperoleh"
                v-model="berkas.jumlah_sks_diperoleh"
                :state="errors.length > 0 ? false : null"
                placeholder="Acuan SIAK NG"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Jumlah SKS diperoleh (Transfer Kredit)
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="jumlah_sks_diperoleh_transfer_kredit"
              rules="required"
            >
              <b-form-input
                id="jumlah_sks_diperoleh_transfer_kredit"
                v-model="berkas.jumlah_sks_diperoleh_transfer_kredit"
                :state="errors.length > 0 ? false : null"
                placeholder="SKS Transfer Kredit"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group title="Untuk Melihat Total SKS Lulus, Silahkan cek pada SIAK NG.">
            <label for="">
              Total SKS Lulus
              <span style="color: red; font-size: 16px">* </span>
              <feather-icon icon="InfoIcon" />
            </label>
            <validation-provider #default="{ errors }" name="keterangan_kekurangan_sks">
              <b-form-input
                id="keterangan_kekurangan_sks"
                v-model="berkas.keterangan_kekurangan_sks"
                :state="errors.length > 0 ? false : null"
                placeholder="Total SKS Lulus"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            title="Untuk Melihat Total Mutu yang diperoleh, Silahkan cek pada SIAK NG."
          >
            <label for=""
              >Total Mutu diperoleh <span style="color: red; font-size: 16px">* </span
              ><feather-icon icon="InfoIcon"
            /></label>
            <validation-provider
              #default="{ errors }"
              name="jumlah_mutu_diperoleh"
              rules="required"
            >
              <b-form-input
                id="jumlah_mutu_diperoleh"
                v-model="berkas.jumlah_mutu_diperoleh"
                :state="errors.length > 0 ? false : null"
                placeholder="Acuan SIAK NG"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >Jumlah SKS Semester ini yang sedang diambil
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="jumlah_sks_semester_ini"
              rules="required"
            >
              <b-form-input
                id="jumlah_sks_semester_ini"
                v-model="berkas.jumlah_sks_semester_ini"
                :state="errors.length > 0 ? false : null"
                placeholder="Jumlah SKS Semester ini"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for=""
              >IPK (Sebelum Ujian Skripsi)
              <span style="color: red; font-size: 16px">*</span></label
            >
            <validation-provider
              #default="{ errors }"
              name="ipk_sebelum_ujian"
              rules="required"
            >
              <b-form-input
                id="ipk_sebelum_ujian"
                v-model="berkas.ipk_sebelum_ujian"
                :state="errors.length > 0 ? false : null"
                placeholder="Acuan SIAK NG"
                type="number"
                :disabled="true"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Ripple from "vue-ripple-directive";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    ValidationProvider,
    FlatPickr,
    vSelect,
  },
  props: {
    berkas: {},
    masterData: {},
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showSpinner: 0,
      showSpinnerPembimbing: 0,
      showSpinnerPenguji: 0,
      counter: 0,
      flatpickrConfig: {
        dateFormat: "Y-m-d",
      },
      ConfigTanggalUjian: {
        enableTime: false, // Adjust as needed
        dateFormat: "d-m-Y",
        disable: [],
        locale: Indonesian,
        timeZone: "Asia/Jakarta",
      },
      jawabanPersetujuanOption: {
        selected: "id",
        options: [{ value: null, title: "--Pilih Jawaban --" }],
      },
      dosenOption: {
        selected: "id",
        options: [{ value: null, title: "--Pilih Dosen --" }],
      },
      dosenUtamaOption: {
        selected: "id",
        options: [
          { value: null, title: "Pilih" },
          { value: "ya", title: "Ya" },
          { value: "tidak", title: "Tidak" },
        ],
      },
      waktuUjianOption: {
        selected: "id",
        options: [{ value: null, title: "--Pilih Waktu --" }],
      },
    };
  },
};
</script>

<style scoped>
/* Tambahkan gaya kustom Anda di sini */
</style>
